import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetInterventionTypesInputDto, InterventionTypeCreateDto, InterventionTypeDto, InterventionTypeExcelDownloadDto, InterventionTypeUpdateDto } from '../dtos/intervention-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class InterventionTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: InterventionTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionTypeDto>({
      method: 'POST',
      url: '/api/planning/interventionTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/interventionTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/interventionTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionTypeDto>({
      method: 'GET',
      url: `/api/planning/interventionTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/interventionTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetInterventionTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InterventionTypeDto>>({
      method: 'GET',
      url: '/api/planning/interventionTypes',
      params: { name: input.name, code: input.code, shouldValidateInventory: input.shouldValidateInventory, shouldCreateNewRotation: input.shouldCreateNewRotation, shouldCheckStumpApplication: input.shouldCheckStumpApplication, shouldCheckApplyFeller: input.shouldCheckApplyFeller, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: InterventionTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/interventionTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, shouldValidateInventory: input.shouldValidateInventory, shouldCreateNewRotation: input.shouldCreateNewRotation, shouldCheckStumpApplication: input.shouldCheckStumpApplication, shouldCheckApplyFeller: input.shouldCheckApplyFeller, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionTypeDto[]>({
      method: 'GET',
      url: '/api/planning/interventionTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: InterventionTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InterventionTypeDto>({
      method: 'PUT',
      url: `/api/planning/interventionTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}